import { render } from "./ApprovalView.vue?vue&type=template&id=1a7597d2"
import script from "./ApprovalView.vue?vue&type=script&lang=js"
export * from "./ApprovalView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__